import { Title, Text, Button, Group, Paper, Container } from "@mantine/core";

export function FirestoreIndexError({ error }) {
  return (
    <Container size="md" py="xl">
      <Paper shadow="sm" p="xl" radius="md" withBorder>
        <Title order={3} color="red" mb="md">
          Error loading data
        </Title>
        <Text mb="md">{error.message}</Text>
        {error.indexUrl && (
          <>
            <Text size="sm" c="dimmed" mb="xs">
              Please visit the URL below to create the required index. Once created, it may take a few minutes to become
              active. You can refresh this page to try again.
            </Text>
            <Text component="pre" mb="md" style={{ wordBreak: "break-all", whiteSpace: "pre-wrap" }}>
              {error.indexUrl}
            </Text>
            <Group>
              <Button
                component="a"
                href={error.indexUrl}
                target="_blank"
                rel="noopener noreferrer"
                variant="light"
                size="sm"
              >
                Open url in new tab
              </Button>
            </Group>
          </>
        )}
      </Paper>
    </Container>
  );
}

export default FirestoreIndexError;
